import "./App.css";
import { useState } from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import CallScreenAfterCall from "./components/Aftercall";
import { LiveKitRoom } from "@livekit/components-react";
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute';
import Register from './components/Register';
import AssistantPage from './components/Assistant';
import Settings from './components/Settings';
import NotionRedirect from './components/NotionRedirect';
import HeygenAvatar from "./components/HeygenLiveAvatar";
import HeygenStreamingComponent from "./heygen/heygen";
import GoogleDocs from "./components/GoogleDocs";
import ChatbotUI from "./components/Chatbot";
import RagTestUI from "./components/RagTest";

function App() {
	const [token, setToken] = useState(null);
	const [url, setUrl] = useState(null);
	const [roomName, setRoomName] = useState(null);
	const [loading, setLoading] = useState(false);
	const [selectedAssistant, setSelectedAssistant] = useState(null);
	const [selectedAssistantId, setSelectedAssistantId] = useState(null);


	const [text, setText] = useState("");
	const [isAvatarConnected, setIsAvatarConnected] = useState(false);

	const username = localStorage.getItem("username");

	const backendUrl = process.env.REACT_APP_BACKEND_URL;

	const handleLogout = () => {
		localStorage.clear();
		setSelectedAssistant(null);
		setSelectedAssistantId(null);
		setToken(null);
		window.location.reload();
	};

	async function getToken() {
		setLoading(true);
		const accessToken = localStorage.getItem("accessToken");
		try {
			const response = await fetch(`${backendUrl}/assistant/create-call-token/?assistantId=${selectedAssistantId}`, {
				headers: {
					Authorization: `Bearer ${accessToken}`,
				},
			});
			if (!response.ok) {
				throw new Error("Failed to fetch token");
			}
			const data = await response.json();

			setToken(data.token);
			setUrl(data.url);
			setRoomName(data.room_);
		} catch (error) {
			console.error("Error fetching token:", error);
			setToken(null);
			setUrl(null);
		} finally {
			setLoading(false);
		}
	}

	function endCall() {
		setToken(null);
		setUrl(null);
		setRoomName(null);
	}

	return (
		<Router>
			<Routes>
				<Route
					path="/"
					element={
						<ProtectedRoute>
							<div className="app">
								{!selectedAssistant ? (
									<>
										<header className="app-header assistant-title">
											<h1 className="username">{username}</h1>
										</header>

										<section className="assistant-list">
											<AssistantPage
												setSelectedAssistant={setSelectedAssistant}
												setSelectedAssistantId={setSelectedAssistantId}
											/>
										</section>
									</>
								) : (
									<>
										<header className="app-header assistant-title">
											<h1 className="username">Username: {localStorage.getItem("username")}</h1>
											<button className="logout-button" onClick={handleLogout}>Logout</button>
										</header>
										<div className='call-screen'>
											<Settings id={selectedAssistantId} />
											<div>
												{token ? (
													<>
														{isAvatarConnected && (
															<LiveKitRoom
																token={token}
																serverUrl={url}
																connectOptions={{ autoSubscribe: true }}
															>
																<CallScreenAfterCall endCall={endCall} setText={setText} />

															</LiveKitRoom>)}
														<HeygenAvatar roomName={roomName} setText={setText} text={text} setIsAvatarConnected={setIsAvatarConnected} />
													</>
												) : (
													<button
														className="start-call-button"
														onClick={getToken}
														disabled={loading}
													>
														{loading ? "Connecting..." : "Start Call"}
													</button>
												)}
											</div>
										</div>
									</>
								)}
								{/* <HeygenAvatar token={token} roomName={roomName}/> */}
							</div>
						</ProtectedRoute>
					}
				/>
				<Route path="/login" element={<Login />} />
				<Route path="/register" element={<Register />} />
				<Route path="/notion" element={<NotionRedirect />} />
				<Route path="/google-docs" element={<GoogleDocs />} />
				<Route path="/heygen" element={<HeygenStreamingComponent />} />
				<Route path="/chat" element={<ChatbotUI />} />
				<Route path="/rag-test" element={<RagTestUI />} />
			</Routes>
		</Router>
	);
}

export default App;
